import React, { Fragment } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Schema } from "@sparefoot/react-commons";
import {
	useCoreWebVitalMetrics
	// useGTMPageViewEvent
} from "@sparefoot/react-commons/hooks";
import { metaPropTypes } from "config/propTypes";
import { Head } from "components/core/Head";
import { TrackingPixel } from "components/core/TrackingPixel";
import { websiteSchema, organizationSchema } from "config/schemas";

import "./Page.scss";

const GlobalPageSchemas = ({ isCLP = false, isSearchPage = false }) => (
	<>
		{!isCLP && !isSearchPage && (
			<>
				<Schema schema={websiteSchema} />
				<Schema schema={organizationSchema} />
			</>
		)}
	</>
);

export const Page = ({
	children,
	className,
	verticalSpacing,
	title,
	description,
	canonical,
	noIndex,
	trackingPixelUrl,
	pageType,
	socialImageUrl,
	isCLP,
	isSearchPage
}) => {
	// useGTMPageViewEvent(pageType);
	useCoreWebVitalMetrics(pageType);
	return (
		<Fragment>
			<Head
				title={title}
				description={description}
				canonical={canonical}
				noIndex={noIndex}
				socialImageUrl={socialImageUrl}
			/>
			<div
				className={classnames("page", className, {
					"vertical-spacing": verticalSpacing
				})}
			>
				{children}
			</div>
			<GlobalPageSchemas isCLP={isCLP} isSearchPage={isSearchPage} />
			{!!trackingPixelUrl && <TrackingPixel src={trackingPixelUrl} />}
		</Fragment>
	);
};

Page.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	verticalSpacing: PropTypes.bool,
	isCLP: PropTypes.bool,
	isSearchPage: PropTypes.bool,
	...metaPropTypes
};

GlobalPageSchemas.propTypes = {
	isCLP: PropTypes.bool,
	isSearchPage: PropTypes.bool
};

export default Page;
